import { Select } from "@mui/material";
import { palette } from "../theme/palette";
import { withStyles } from "@mui/styles";

const StyledSelect = withStyles({
  root: {
    minWidth: "100px",
    fontSize: "12px",
    height: "18px",
    color: palette.typography.white.high,
  },
  icon: {
    color: palette.typography.white.high,
  },
  disabled: {
    "& path": {
      color: palette.typography.black.disabled,
    },
  },
})(Select);

export default StyledSelect;
